import { HttpService } from "@/core";

export class WorkbenchService {
  // 工作台-租户信息
  static workbenchInfo() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: "/tenant/work/tenant/info",
        params,
      });
    return HttpService.usePagination<any>(api);
  }
  // 工作台-合同信息
  static workbenchContract() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: "/electronic_contract/workbench/contract",
        params,
      });
    return HttpService.usePagination<any>(api);
  }
  // 批量查询个人/企业实名认证状态
  static verifyShiMing() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/fadadaApi/findVerify/by/info",
        data: data,
      });

    return HttpService.useRequest<any>(api);
  }
  // AI执行
  static aiRun() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/contractAI/aiRun",
        data: data,
      });

    return HttpService.useRequest<any>(api);
  }
  // AI执行结果
  static getWorkflowResult() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/contractAI/getWorkflowResult",
        data: data,
      });

    return HttpService.useRequest<any>(api);
  }
  // 【合同审查】获取合同审查配置项
  static getContractCheckConfig() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/contractAI/getContractCheckConfig",
        data: data,
      });

    return HttpService.useRequest<any>(api);
  }
  // 【合同审查】导出合同审查结果
  static exportContractCheckResult() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/contractAI/exportContractCheckResult",
        data: data,
      });

    return HttpService.useRequest<any>(api);
  }
  // 【合同审查】AI生产审查清单
  static getContractCheckList() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/contractAI/getContractCheckList",
        data: data,
      });

    return HttpService.useRequest<any>(api);
  }

  // 获取AI历史记录分页
  static getHistoryPage() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/contractAI/getHistoryPage",
        data: data,
      });

    return HttpService.useRequest<any>(api);
  }

  // 删除历史记录
  static deleteBaseHistory() {
    const api = (id) =>
      HttpService.axios({
        method: "POST",
        url: `/contractAI/deleteBaseHistory/${id}`,
      });

    return HttpService.useRequest<any>(api);
  }
}
